/* Trendy · barra fija de compra (15-10-2026). Reemplaza a .tl-sticky / .dw-sticky / la barra de Horizon.

   - Barra: compartir · foto · lo que está elegido (modelo/pack) con el precio REAL que se va a pagar · "Comprar".

   - "Comprar" abre una hoja (<dialog>) con las mismas opciones de la página (se tocan los botones reales, así el

     formulario de la página sigue siendo la única fuente de verdad), el total, el despacho real (lee el bloque

     trendy-despacho de la página) y los dos pagos: online primero, al recibir segundo. Cada pago hace click en el

     botón real de la página (Mercado Pago / Releasit), así no se duplica ninguna lógica de compra.

   - Compartir: hoja nativa del celular si existe (iPhone, Chrome); si no (el navegador de Facebook/Instagram en

     Android NO tiene navigator.share), una hoja propia con WhatsApp y "Copiar link". Links con UTM, sin fbclid.

   - Se esconde cuando el formulario de compra está en pantalla, en el pie, con el teclado abierto, con el aviso de

     cookies, y debajo de cualquier capa (Explorar, cajón, hoja de FB, Releasit).

   Sin dependencias, sin listeners de scroll; solo transform/opacity. Config opcional en #tsb-cfg (snippet).

   15-10 (revisión): historial a prueba del replaceState de la página, repintado único por cuadro, hoja que se

   actualiza en el lugar (no pierde el foco), precio por unidad tomado de la página, modo liviano (tr-lite).

   16-10 (14.2): el online de la hoja dice "Envío desde $200" como el de la ficha (CFG.envio_online: sale de env_correo

   de trendy-ofertas); si la hoja no entra en la pantalla, los dos pagos quedan pegados al pie (en un celular bajo

   "Pagá al recibir" quedaba abajo del borde); el cierre "Elegí tu pack ↑" (data-tsb-abrir) abre la hoja y, con

   todo agotado, sube a los packs como antes en vez de mandar a WhatsApp. */

(function () {

  'use strict';

  if (window.__tsb) return;

  var d = document, H = d.documentElement, W = window;

  function q(s, r) { return (r || d).querySelector(s); }

  function qa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  function txt(el, s) { var e = el && (s ? q(s, el) : el); return e ? (e.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  function plata(s) { if (typeof s === 'number') return s; var t = String(s || '').replace(/[^\d,]/g, '').split(',')[0]; return t ? parseInt(t, 10) : 0; }

  function fmt(n) { return '$' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function quieto() { return (W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches) || H.classList.contains('tr-lite'); }

  /* visible de verdad (offsetParent da null para cosas position:fixed) */

  function vis(el) {

    if (!el) return false;

    if (el.checkVisibility) return el.checkVisibility({ visibilityProperty: true, opacityProperty: true });

    var cs = getComputedStyle(el); return el.getClientRects().length > 0 && cs.visibility !== 'hidden' && +cs.opacity > 0;

  }

  var VH = '<span class="tsb-vh">antes </span>';



  function init() {

    if (window.__tsb) return;

    var CFG = {}; try { CFG = JSON.parse(q('#tsb-cfg').textContent) || {}; } catch (e) {}

    if (CFG.off) return;



    /* ── qué tipo de ficha es ─────────────────────────────── */

    var fam, root, form;

    if ((root = q('[data-tl-root]'))) { fam = 'tl'; form = q('#tl-form', root); }

    else if ((root = q('#dw-landing'))) { fam = 'dw'; form = q('#dw-form', root); }

    else if ((form = q('main product-form-component'))) { fam = 'gen'; root = q('main'); }

    if (!fam || !form) return;

    window.__tsb = 1;

    H.classList.add('tsb-mounted');

    var viejaBarra = q('.tl-sticky small, .dw-sticky small');   /* su texto es el nombre corto del producto */

    var viejo = CFG.viejo || (viejaBarra ? txt(viejaBarra) : '');

    qa('.tl-sticky,.dw-sticky').forEach(function (e) { e.parentNode && e.parentNode.removeChild(e); });

    /* una entrada {tsb} que quedó de otra visita (recarga del WebView) no debe quedar colgada */

    try { if (history.state && history.state.tsb) { var st0 = Object.assign({}, history.state); delete st0.tsb; history.replaceState(st0, ''); } } catch (e) {}



    function btnOnline() { return fam === 'tl' ? q('[data-tl-online]', root) : fam === 'dw' ? q('[data-dw-online]', root) : q('product-form-component .tr-on, product-form-component .online-checkout-btn', root); }

    function btnCod() { return fam === 'tl' ? q('[data-tl-cod]', root) : fam === 'dw' ? q('[data-dw-cod]', root) : q('#_rsi-buy-now-button', root) || q('#_rsi-buy-now-button'); }

    var qtyIn = q('#tl-qty, #dw-qty', root) || q('[name="quantity"]', form);



    /* ── nombre, foto, link ───────────────────────────────── */

    function capital(s) { s = s.toLowerCase(); return s.charAt(0).toUpperCase() + s.slice(1); }

    var og = q('meta[property="og:image"]'), ogt = q('meta[property="og:title"]');

    var nombre = CFG.nombre || (viejo ? capital(viejo) : '') || (ogt ? ogt.content.split(/\s[—–|-]\s/)[0] : d.title.split(/\s[—–|-]\s/)[0]);

    function ancho(u, w) { if (!u) return ''; u = u.replace(/^http:/, 'https:').replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''); return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

    var fotoBase = CFG.img || (og ? og.content : '');

    var pathProd = location.pathname.replace(/^.*(\/products\/[^/?#]+).*$/, '$1');

    var base = CFG.url || (location.origin + pathProd);

    var disponible = CFG.available !== false;

    var envOnline = typeof CFG.envio_online === 'string' ? CFG.envio_online.trim() : '';   /* "$200"; vacío = no se muestra (env_correo 0 o producto sin envío) */

    var tlData = {}; try { tlData = JSON.parse(txt(q('#tl-data'))); } catch (e) {}

    var dwData = {}; try { dwData = JSON.parse(txt(q('#dw-data'))); } catch (e) {}



    /* ── opciones de la página (packs / modelos / bidón / packs de kinoki) ── */

    var OPC = '[data-tl-pack],[data-tf-variant],[data-dw-variant],.kp-card';

    var TIT = { modelo: 'Elegí el modelo', pack: '¿Cuántos querés?', dw: '¿Qué bidón tenés?', kp: 'Elegí tu pack' };

    function tipo(el) { return el.hasAttribute('data-tl-pack') ? 'pack' : el.hasAttribute('data-tf-variant') ? 'modelo' : el.hasAttribute('data-dw-variant') ? 'dw' : 'kp'; }

    function elegido(el) { return el.getAttribute('aria-checked') === 'true' || el.getAttribute('aria-pressed') === 'true'; }

    function varDw(id) { var v = null; (dwData.variants || []).forEach(function (x) { if (String(x.id) === String(id)) v = x; }); return v; }

    function opcion(el) {

      var img = q('.tf-vimg img', el);

      var flag = q('[class$="-flag"], [class*="-flag "]', el);

      var id = el.getAttribute('data-tf-variant') || el.getAttribute('data-dw-variant') || '';

      var v = el.hasAttribute('data-dw-variant') ? varDw(id) : null;

      return {

        el: el, tipo: tipo(el), on: elegido(el), id: id,

        n: txt(el, '.tl-pkn, .dw-pkn, .kp-name') || txt(el).slice(0, 40),

        sub: txt(el, '.tl-pkd, .dw-pkd, .kp-sub'),

        now: plata(txt(el, '.tl-pr u, .dw-pkp, .kp-now') || el.getAttribute('data-price') / 100 || el.getAttribute('data-kp-price')),

        was: plata(txt(el, '.tl-pr s, .dw-pkv, .kp-was')),

        unidadTxt: txt(el, '.tl-pr em'),          /* "$198 c/esponja": el precio por unidad lo dice la página */

        flag: flag ? txt(flag) : '', img: img ? img.currentSrc || img.src : '',

        agotado: !!(v && v.available === false)

      };

    }

    /* 16-10-2026 (14.4): el título del grupo de modelos sale de la ficha si lo tiene (ajuste modelos_titulo, "Elegí tu modelo") */

    function tituloGrupo(el, k) {

      if (k !== 'modelo') return TIT[k];

      var g = el.closest('[role="radiogroup"]'), id = g && g.getAttribute('aria-labelledby'), lb = id && d.getElementById(id);

      return (lb && txt(lb)) || TIT[k];

    }

    function grupos() {

      var orden = [], map = {};

      qa(OPC, root).forEach(function (el) {

        if (el.closest('.tsb, dialog')) return;

        if (fam !== 'gen' && !vis(el)) return;

        var o = opcion(el), k = o.tipo;

        if (!map[k]) { map[k] = { k: k, t: tituloGrupo(el, k), items: [] }; orden.push(map[k]); }

        map[k].items.push(o);

      });

      orden.forEach(function (g) {   /* el dispensador ordena sus opciones con CSS order */

        if (g.k === 'dw') g.items.sort(function (a, b) { return (parseInt(getComputedStyle(a.el).order, 10) || 0) - (parseInt(getComputedStyle(b.el).order, 10) || 0); });

        g.sel = g.items.filter(function (o) { return o.on; })[0] || null;

      });

      orden.sort(function (a, b) { return (a.k === 'pack' || a.k === 'kp') - (b.k === 'pack' || b.k === 'kp'); });   /* modelo antes que cantidad */

      return orden;

    }



    /* ── estado: lo que la página ya calculó ──────────────── */

    function estado() {

      var gs = grupos(), pack = null, modelo = null;

      gs.forEach(function (g) { if (g.k === 'pack' || g.k === 'kp') pack = g.sel; else modelo = g.sel; });

      var qty = Math.max(1, parseInt(qtyIn && qtyIn.value, 10) || 1);

      var total = 0, lista = 0, unidad = 0, agotadoVar = false;

      if (fam === 'tl') {

        unidad = modelo ? modelo.now : (tlData.price || 0) / 100;

        if (pack && tlData.price) {   /* misma cuenta que trendy-landing.js: no depende de que ya haya pintado */

          var n = Number(pack.el.getAttribute('data-qty') || 1), desc = Number(pack.el.getAttribute('data-desc') || 0);

          var precio = modelo && modelo.now ? modelo.now * 100 : tlData.price;

          total = (precio * n - desc) / 100; qty = n;

          lista = pack.was || ((modelo && modelo.was ? modelo.was * 100 : (tlData.compare || tlData.price)) * n / 100);

        } else {

          total = plata(txt(q('#tl-form [data-tl-total]', root) || q('[data-tl-total]', root))) || unidad * qty;

          lista = modelo && modelo.was ? modelo.was * qty : (tlData.compare || 0) / 100 * qty;

        }

      } else if (fam === 'dw') {

        var v = varDw(modelo ? modelo.id : (q('[name="id"]', form) || {}).value);

        unidad = v ? v.price / 100 : (modelo ? modelo.now : 0);

        total = unidad * qty || plata(txt(q('[data-dw-total]', root)));

        lista = v && v.compare > v.price ? v.compare / 100 * qty : (modelo && modelo.was ? modelo.was * qty : 0);

        agotadoVar = !!(v && v.available === false);

      } else {

        var pp = q('product-price', root);

        unidad = plata(txt(pp && (q('.price-item--sale, .price-item--regular, .price', pp) || pp)));

        total = pack ? pack.now : unidad * qty;

        lista = pack && pack.was ? pack.was : plata(txt(pp && q('s, .compare-at-price, .price-item--compare', pp))) * qty;

      }

      if (!total) total = unidad * qty;

      if (!(lista > total)) lista = 0;

      var partes = [];

      if (modelo) partes.push(modelo.n.split('·')[0].trim());

      if (pack) partes.push(pack.n);

      var agotadoTodo = !disponible || (fam === 'dw' && (dwData.variants || []).length && (dwData.variants || []).every(function (x) { return x.available === false; }));

      return { gs: gs, pack: pack, modelo: modelo, qty: qty, total: total, lista: lista, unidad: unidad,

        etiqueta: partes.join(' · '), img: (modelo && modelo.img) || '', agotadoVar: agotadoVar, agotadoTodo: !!agotadoTodo };

    }



    /* ── despacho: el bloque real de la página (trendy-despacho) ── */

    function despacho() { var t = q('.tdp [data-tdp-top]'); return (t ? txt(t) : '') || 'Llega en 24–72 h hábiles a todo Uruguay'; }



    /* ── la barra ─────────────────────────────────────────── */

    var ICO = {

      share: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v12"/><path d="M7.5 7.5 12 3l4.5 4.5"/><path d="M5 12v6.5A2.5 2.5 0 0 0 7.5 21h9a2.5 2.5 0 0 0 2.5-2.5V12"/></svg>',

      x: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',

      bolsa: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 8h12l-1 12H7z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>',

      camion: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',

      wa: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.7.8-.8 1-.3.2-.6.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.1.7a2.7 2.7 0 0 0 1.8-1.3 2.2 2.2 0 0 0 .2-1.3c-.1-.1-.3-.2-.5-.3z"/></svg>',

      copia: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="8" y="8" width="12" height="12" rx="2.5"/><path d="M16 8V6.5A2.5 2.5 0 0 0 13.5 4h-7A2.5 2.5 0 0 0 4 6.5v7A2.5 2.5 0 0 0 6.5 16H8"/></svg>'

    };

    var bar = d.createElement('div');

    bar.className = 'tsb';

    bar.setAttribute('role', 'region');

    bar.setAttribute('aria-label', 'Compra rápida: ' + nombre);

    bar.innerHTML =

      '<button type="button" class="tsb__sh" data-tsb-share aria-label="Compartir">' + ICO.share + '</button>' +

      '<button type="button" class="tsb__info" data-tsb-open>' +

        '<img class="tsb__img" alt="" width="44" height="44" decoding="async" loading="lazy" hidden>' +

        '<span class="tsb__tx"><span class="tsb__l1"></span><span class="tsb__l2"><b></b><s></s></span><span class="tsb__l3"></span></span>' +

        '<span class="tsb-vh">. Ver opciones y comprar</span>' +

      '</button>' +

      '<button type="button" class="tsb__cta" data-tsb-open aria-haspopup="dialog" aria-controls="tsb-sheet" aria-expanded="false">' + ICO.bolsa + '<span>Comprar</span></button>';

    d.body.appendChild(bar);

    /* el aviso para lectores de pantalla vive afuera de la barra (la barra pasa a oculta/inerte con la hoja abierta) */

    var bLive = d.createElement('span'); bLive.className = 'tsb-vh'; bLive.setAttribute('aria-live', 'polite'); d.body.appendChild(bLive);

    var bImg = q('.tsb__img', bar), bL1 = q('.tsb__l1', bar), bPr = q('.tsb__l2 b', bar), bWas = q('.tsb__l2 s', bar), bL3 = q('.tsb__l3', bar), bCta = q('.tsb__cta', bar);

    try { new ResizeObserver(function () { H.style.setProperty('--tsb-h', bar.offsetHeight + 'px'); }).observe(bar); } catch (e) { H.style.setProperty('--tsb-h', '80px'); }



    var hoja = null, share = null;

    var ultimo = '';

    function pintarBarra() {

      var e = estado();

      var foto = e.img || ancho(fotoBase, 96);

      if (foto) { if (bImg.getAttribute('src') !== foto) bImg.src = foto; bImg.hidden = false; }

      /* nombre + opción si entra en una línea; si no, solo la opción (la foto y el precio ya dicen qué es) */

      bL1.textContent = !e.etiqueta ? nombre : (nombre.length + e.etiqueta.length <= 27 ? nombre + ' · ' + e.etiqueta : e.etiqueta);

      bPr.textContent = fmt(e.total);

      bWas.innerHTML = e.lista ? VH + fmt(e.lista) : '';

      bar.classList.toggle('is-agotado', e.agotadoTodo);

      bL3.textContent = e.agotadoTodo ? 'Sin stock por ahora' : e.agotadoVar ? 'Esta opción está sin stock' : '12 cuotas o al recibir';

      q('span', bCta).textContent = e.agotadoTodo ? 'Consultar' : 'Comprar';

      if (e.agotadoTodo) bCta.removeAttribute('aria-haspopup'); else bCta.setAttribute('aria-haspopup', 'dialog');

      var clave = e.etiqueta + '|' + e.total;

      if (clave !== ultimo) {

        if (ultimo && !(hoja && hoja.open)) {

          bLive.textContent = (e.etiqueta || nombre) + ', ' + fmt(e.total) + (e.lista ? ', ahorrás ' + fmt(e.lista - e.total) : '');

          if (!quieto()) { bar.classList.remove('is-pulso'); void bar.offsetWidth; bar.classList.add('is-pulso'); }

        }

        ultimo = clave;

      }

      if (hoja && hoja.open) pintarHoja(e);

    }



    /* cambios en la página → barra (la página recalcula en el click; leemos en el cuadro siguiente, una sola vez) */

    var cola = 0;

    function luego() { if (cola) return; cola = 1; requestAnimationFrame(function () { requestAnimationFrame(function () { cola = 0; pintarBarra(); }); }); }

    root.addEventListener('click', function (ev) { if (ev.target.closest && ev.target.closest(OPC + ', [data-dw-step], quantity-selector-component button')) luego(); }, true);

    root.addEventListener('input', luego, true);

    root.addEventListener('change', luego, true);

    root.addEventListener('quantity-selector:update', luego);

    d.addEventListener('kp:change', luego);

    d.addEventListener('variant:update', luego);

    if (d.readyState !== 'complete') d.addEventListener('DOMContentLoaded', luego, { once: true });

    W.addEventListener('pageshow', function () { H.classList.remove('tsb-rsi'); luego(); });



    /* ── analítica (mismo evento que el resto: trendy_cta) ── */

    var UA = navigator.userAgent;

    function medir(tipoEv, extra) {

      var x = { tipo: tipoEv, lugar: 'barra', producto: (W.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id) || null,

        plantilla: fam, fb: /FBAN|FBAV|FB_IAB|FBIOS/i.test(UA) && !/Instagram/i.test(UA), ig: /Instagram/i.test(UA) };

      for (var k in extra) x[k] = extra[k];

      try { if (W.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('trendy_cta', x); } catch (e) {}

      try { if (W.fbq) fbq('trackCustom', 'TrendyCTA', x); } catch (e) {}

    }



    /* ── cuándo se ve ─────────────────────────────────────── */

    var formVisible = false, pieVisible = false, visto = false;

    function cookiesAbiertas() {

      try { var cp = W.Shopify && Shopify.customerPrivacy; if (cp && cp.shouldShowBanner && !cp.shouldShowBanner()) return false; } catch (e) {}

      var b = q('#shopify-pc__banner'); if (!vis(b)) return false;

      var r = b.getBoundingClientRect(); return r.height > 0 && r.top < innerHeight;

    }

    function actualizar() {

      var on = !formVisible && !pieVisible && !cookiesAbiertas();

      H.classList.toggle('tsb-on', on);

      if (on && !visto) { visto = true; medir('barra-vista'); }

    }

    function altoHeader() { var h = q('#header-group') || q('header'); var r = h ? h.getBoundingClientRect() : null; return r && r.bottom > 0 && r.bottom < 220 ? Math.round(r.bottom) : 70; }

    var obj = fam === 'gen' ? (q('.product-form-buttons, [data-tr-botones]', form) || form) : form;

    var io = null;

    function observar() {

      if (!('IntersectionObserver' in W)) { formVisible = false; actualizar(); return; }

      if (io) io.disconnect();

      io = new IntersectionObserver(function (es) { es.forEach(function (x) { if (x.target === obj) formVisible = x.isIntersecting; else pieVisible = x.isIntersecting; }); actualizar(); },

        { rootMargin: '-' + (altoHeader() + 8) + 'px 0px -24px 0px', threshold: 0 });

      io.observe(obj);

      var pie = q('footer, .shopify-section-group-footer-group');

      if (pie) io.observe(pie);

    }

    observar();

    var rT; W.addEventListener('resize', function () { clearTimeout(rT); rT = setTimeout(function () { observar(); marcarDesborde(); }, 250); });

    d.addEventListener('visitorConsentCollected', function () { setTimeout(actualizar, 50); });

    /* el aviso de cookies puede aparecer tarde: mirar el body un rato (solo hijos nuevos) */

    try {

      var moC = new MutationObserver(function () { actualizar(); });

      moC.observe(d.body, { childList: true });

      setTimeout(function () { moC.disconnect(); actualizar(); }, 10000);

    } catch (e) { setTimeout(actualizar, 1500); setTimeout(actualizar, 4000); }

    /* teclado: un campo de texto con foco lo pone; el alto del viewport visible lo confirma o lo saca */

    var TXT = 'input:not([type=radio]):not([type=checkbox]):not([type=hidden]):not([type=button]):not([type=submit]),textarea';

    function campo(a) { return a && a.matches && a.matches(TXT) && !a.closest('dialog.tsb-share'); }

    d.addEventListener('focusin', function (e) { if (campo(e.target)) H.classList.add('tsb-kb'); });

    d.addEventListener('focusout', function () { setTimeout(function () { if (!campo(d.activeElement)) H.classList.remove('tsb-kb'); }, 60); });

    if (W.visualViewport) W.visualViewport.addEventListener('resize', function () {

      var vv = W.visualViewport; if (vv.scale && Math.abs(vv.scale - 1) > .01) return;   /* zoom con dos dedos: no es el teclado */

      var gap = W.innerHeight - vv.height;

      if (gap > 150 && campo(d.activeElement)) H.classList.add('tsb-kb'); else if (gap < 100) H.classList.remove('tsb-kb');

    });

    /* Releasit: mientras su formulario está abierto la barra no aparece (se limpia al cerrarlo o al volver) */

    var rsiT = 0;

    function vigilarRsi() {

      clearInterval(rsiT); var n = 0;

      rsiT = setInterval(function () {

        n++;

        var abierto = qa('[id^="_rsi"], [class*="_rsi-modal"], [class*="rsi-form"], iframe[src*="releasit"]').some(function (el) { return el.id !== '_rsi-buy-now-button' && vis(el) && el.getBoundingClientRect().height > 200; });

        if ((n > 6 && !abierto) || n > 600) { H.classList.remove('tsb-rsi'); clearInterval(rsiT); }

      }, 500);

    }



    /* ── historial: la hoja suma una entrada para que "atrás" la cierre ──

       La página de la bolsa hace history.replaceState({}, …) al cambiar de modelo y borraría la marca: mientras una

       hoja está abierta, cualquier replaceState conserva {tsb:1}. */

    var hojaEmp = false, shareEmp = false, pendiente = null, urlVuelta = null;

    var rs0 = history.replaceState;

    try {

      history.replaceState = function (s, t, u) {

        if ((hojaEmp || shareEmp) && history.state && history.state.tsb) { s = Object.assign({}, s || {}, { tsb: 1 }); if (u !== undefined) urlVuelta = String(new URL(u, location.href)); }

        return rs0.apply(history, [s, t, u === undefined ? location.href : u]);

      };

    } catch (e) {}

    function empujar() { try { history.pushState(Object.assign({}, history.state || {}, { tsb: 1 }), ''); return true; } catch (e) { return false; } }



    /* ── hoja de compra ───────────────────────────────────── */

    var abridor = null, firma = '';

    var tieneDialog = typeof HTMLDialogElement === 'function' && HTMLDialogElement.prototype && 'showModal' in HTMLDialogElement.prototype;

    function crearHoja() {

      hoja = d.createElement('dialog');

      hoja.className = 'tsb-sheet';

      hoja.id = 'tsb-sheet';

      hoja.setAttribute('aria-labelledby', 'tsb-t');

      hoja.innerHTML = '<div class="tsb-in"><div class="tsb-grab" aria-hidden="true"></div>' +

        '<button type="button" class="tsb-x" data-tsb-x aria-label="Cerrar">' + ICO.x + '</button>' +

        '<div class="tsb-hd"><img alt="" width="56" height="56" decoding="async"><div><p class="tsb-k">Trendy</p><h2 id="tsb-t"></h2></div></div>' +

        '<div data-tsb-gs></div>' +

        '<p class="tsb-aviso" data-tsb-aviso hidden></p>' +

        '<p class="tsb-nota" data-tsb-nota hidden></p>' +

        '<div class="tsb-tot" aria-live="polite" aria-atomic="true"><span>Total</span><b></b><s></s><em hidden></em><small hidden></small></div>' +

        '<p class="tsb-desp">' + ICO.camion + '<span></span></p>' +

        '<div class="tsb-pays">' +

          '<button type="button" class="tsb-pay tsb-pay--on' + (envOnline ? ' tsb-pay--env' : '') + '" data-tsb-pay="online"><b>Pagar online · hasta 12 cuotas</b><small>Pago seguro con Mercado Pago</small>' +

            (envOnline ? '<small class="tsb-pay__env">Envío desde ' + esc(envOnline) + '</small>' : '') + '</button>' +

          '<p class="tsb-cap">¿Preferís pagar en efectivo?</p>' +

          '<button type="button" class="tsb-pay tsb-pay--cod" data-tsb-pay="cod"><b>Pagá al recibir</b><small>Pagás cuando te llega, sin tarjeta</small></button>' +

          (W.trendyTransfer ? '<button type="button" class="tsb-pay tsb-pay--tr" data-tsb-pay="tr"><b>Pagar por transferencia</b><small><b>Envío gratis</b> confirmando por WhatsApp</small></button>' : '') +

        '</div>' +

        '</div>';

      d.body.appendChild(hoja);

      hoja.addEventListener('click', function (ev) {

        if (ev.target === hoja) return cerrar('fondo');

        if (ev.target.closest('[data-tsb-x]')) return cerrar('x');

        var op = ev.target.closest('[data-tsb-op]');

        if (op) { elegir(op); return; }

        var st = ev.target.closest('[data-tsb-step]');

        if (st) { var real = q('[data-dw-step="' + st.getAttribute('data-tsb-step') + '"]', root); if (real) { real.click(); luego(); medir('barra-pack', { cantidad: true }); } return; }

        var pay = ev.target.closest('[data-tsb-pay]');

        if (pay && pay.getAttribute('data-tsb-pay') === 'tr') { medir('barra-transfer'); cerrar(); setTimeout(function () { if (W.trendyTransfer) W.trendyTransfer.abrir(); }, 320); return; }

        if (pay && !pay.disabled) pagar(pay.getAttribute('data-tsb-pay'));

      });

      hoja.addEventListener('keydown', function (ev) {   /* flechas dentro de cada grupo, como un radiogroup */

        var op = ev.target.closest && ev.target.closest('[data-tsb-op]');

        if (!op || ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight'].indexOf(ev.key) < 0) return;

        ev.preventDefault();

        var hermanos = qa('[data-tsb-op]', op.parentNode), i = hermanos.indexOf(op), paso = ev.key === 'ArrowDown' || ev.key === 'ArrowRight' ? 1 : -1;

        var sig = hermanos[(i + paso + hermanos.length) % hermanos.length]; elegir(sig); sig.focus();

      });

      hoja.addEventListener('close', function () {

        bCta.setAttribute('aria-expanded', 'false');

        H.classList.remove('tsb-dlg');

        if (!pendiente && abridor) { var o = abridor; requestAnimationFrame(function () { if (!hoja.open && o.isConnected && vis(o)) try { o.focus({ preventScroll: true }); } catch (e) {} }); }

        if (hojaEmp) { hojaEmp = false; urlVuelta = location.href; history.back(); return; }   /* el popstate corre lo pendiente */

        correrPendiente();

      });

      hoja.addEventListener('cancel', function () { medir('barra-cerrar', { via: 'esc' }); });

    }

    function opHTML(o, gi, oi) {

      return '<button type="button" class="tsb-op' + (o.agotado ? ' is-agotado' : '') + '" role="radio" data-tsb-op="' + gi + ':' + oi + '" aria-checked="' + o.on + '" tabindex="' + (o.on ? 0 : -1) + '">' +

        (o.flag ? '<span class="tsb-op__f">' + esc(o.flag) + '</span>' : '') +

        (o.img ? '<img class="tsb-op__img" src="' + esc(o.img) + '" alt="" width="40" height="40">' : '<span class="tsb-op__r" aria-hidden="true"></span>') +

        '<span class="tsb-op__tx"><b>' + esc(o.n) + '</b>' + (o.agotado ? '<small>Sin stock por ahora</small>' : o.sub ? '<small>' + esc(o.sub) + '</small>' : '') + '</span>' +

        '<span class="tsb-op__pr">' + (o.now ? '<b>' + fmt(o.now) + '</b>' : '') + (o.was > o.now ? '<s>' + VH + fmt(o.was) + '</s>' : '') + '</span></button>';

    }

    var gsCache = [], totClave = '';

    function pintarHoja(e) {

      e = e || estado();

      gsCache = e.gs;

      q('#tsb-t', hoja).textContent = nombre;

      var hi = q('.tsb-hd img', hoja), f = e.img || ancho(fotoBase, 160);

      if (f) { if (hi.getAttribute('src') !== f) hi.src = f; hi.hidden = false; } else hi.hidden = true;

      /* opciones: se arman una vez; después solo se actualiza el marcado (así no se pierde el foco) */

      var nuevaFirma = e.gs.map(function (g) { return g.k + ':' + g.items.map(function (o) { return o.n; }).join(','); }).join('|') + (fam === 'dw' ? '|qty' : '');

      var caja = q('[data-tsb-gs]', hoja);

      if (nuevaFirma !== firma) {

        firma = nuevaFirma;

        var html = '';

        e.gs.forEach(function (g, gi) {

          if (g.items.length < 2) return;

          html += '<fieldset class="tsb-g"><legend>' + esc(g.t) + '</legend><div class="tsb-ops" role="radiogroup" aria-label="' + esc(g.t) + '">' +

            g.items.map(function (o, oi) { return opHTML(o, gi, oi); }).join('') + '</div></fieldset>';

        });

        if (fam === 'dw' && q('[data-dw-step]', root)) {

          html += '<div class="tsb-qty"><span id="tsb-qt">Cantidad</span><div><button type="button" data-tsb-step="-1" aria-label="Quitar uno">−</button><output aria-labelledby="tsb-qt">' + e.qty + '</output><button type="button" data-tsb-step="1" aria-label="Agregar uno">+</button></div></div>';

        }

        caja.innerHTML = html;

      } else {

        e.gs.forEach(function (g, gi) {

          g.items.forEach(function (o, oi) {

            var b = q('[data-tsb-op="' + gi + ':' + oi + '"]', caja); if (!b) return;

            b.setAttribute('aria-checked', o.on ? 'true' : 'false'); b.tabIndex = o.on ? 0 : -1;

          });

        });

        var out = q('.tsb-qty output', caja); if (out) out.textContent = e.qty;

      }

      /* total: se reescribe solo si cambió (el lector de pantalla lo lee una vez) */

      var porUnidad = '';

      if (e.pack && e.pack.unidadTxt) porUnidad = e.pack.unidadTxt;

      else if (!e.pack && e.qty > 1) porUnidad = fmt(e.total / e.qty) + ' c/u · ' + e.qty + ' unidades';

      var clave = e.total + '|' + e.lista + '|' + porUnidad;

      if (clave !== totClave) {

        totClave = clave;

        var tot = q('.tsb-tot', hoja);

        q('b', tot).textContent = fmt(e.total);

        q('s', tot).innerHTML = e.lista ? VH + fmt(e.lista) : '';

        var em = q('em', tot); em.hidden = !e.lista; em.textContent = e.lista ? 'Ahorrás ' + fmt(e.lista - e.total) : '';

        var sm = q('small', tot); sm.hidden = !porUnidad; sm.textContent = porUnidad;

      }

      q('.tsb-desp span', hoja).textContent = despacho();

      /* 16-10-2026: aviso de la ficha (p. ej. color surtido de la bolsa), antes de los botones de pago */

      var av = q('[data-tsb-aviso]', hoja), avTxt = (root && root.getAttribute('data-tsb-aviso')) || '';

      if (av) { av.hidden = !avTxt; if (av.textContent !== avTxt) av.textContent = avTxt; }

      /* 16-10-2026 (14.4): junto al aviso, la nota de precio por unidad de la ficha (data-tsb-nota) */

      var nt = q('[data-tsb-nota]', hoja), ntTxt = (root && root.getAttribute('data-tsb-nota')) || '';

      if (nt) { nt.hidden = !ntTxt; if (nt.textContent !== ntTxt) nt.textContent = ntTxt; }

      qa('[data-tsb-pay]', hoja).forEach(function (b) { b.disabled = e.agotadoVar; b.hidden = e.agotadoTodo; });

      q('.tsb-cap', hoja).textContent = e.agotadoVar ? 'Esta opción está sin stock por ahora: elegí otra.' : '¿Preferís pagar en efectivo?';

      marcarDesborde();

    }

    /* 16-10 (14.2): si la hoja no entra en la pantalla, los pagos quedan pegados al pie (CSS .tsb-pays, sticky). Acá solo

       se marca la hoja (sombra arriba de los pagos) y se reserva su alto para que el foco del teclado no quede tapado. */

    function marcarDesborde() {

      if (!hoja || !hoja.open) return;

      var i = q('.tsb-in', hoja), p = q('.tsb-pays', hoja);

      if (!i || !p) return;

      var des = i.scrollHeight > i.clientHeight + 1;

      hoja.classList.toggle('is-desborda', des);

      i.style.scrollPaddingBottom = des ? p.offsetHeight + 'px' : '';

    }

    function elegir(op) {

      var p = op.getAttribute('data-tsb-op').split(':'), g = gsCache[+p[0]], o = g && g.items[+p[1]];

      if (!o) return;

      if (!elegido(o.el)) { o.el.click(); medir('barra-pack', { opcion: o.n }); }

      luego();

    }

    function abrir() {

      var e = estado();

      if (e.agotadoTodo) { location.href = 'https://wa.me/59895440747?text=' + encodeURIComponent('Hola, ¿cuándo vuelve ' + nombre + (e.etiqueta ? ' (' + e.etiqueta + ')' : '') + '? ' + base); return; }

      medir('barra');

      if (!tieneDialog) return irAlForm();

      if (!hoja) crearHoja();

      cerrarCompartir();

      abridor = (d.activeElement && d.activeElement !== d.body && !d.activeElement.closest('dialog')) ? d.activeElement : bCta;

      pintarHoja(e);

      hoja.showModal();

      H.classList.add('tsb-dlg');

      marcarDesborde();

      bCta.setAttribute('aria-expanded', 'true');

      hojaEmp = empujar();

      var sel = q('.tsb-op[aria-checked="true"]', hoja) || q('[data-tsb-pay="online"]', hoja);

      if (sel) try { sel.focus({ preventScroll: true }); } catch (x) {}

      if (navigator.vibrate && !quieto()) try { navigator.vibrate(8); } catch (x) {}

    }

    function cerrar(via) { if (via) medir('barra-cerrar', { via: via }); if (hoja && hoja.open) hoja.close(); }

    W.addEventListener('popstate', function () {

      if (hoja && hoja.open && hojaEmp) { hojaEmp = false; hoja.close(); }

      if (share && share.open && shareEmp) { shareEmp = false; share.close(); }

      /* al volver, la URL queda con el modelo que se eligió en la hoja (?variant=…) */

      if (urlVuelta && urlVuelta !== location.href) try { rs0.call(history, history.state, '', urlVuelta); } catch (e) {}

      urlVuelta = null;

      correrPendiente();

    });

    function correrPendiente() { if (pendiente) { var f = pendiente; pendiente = null; setTimeout(f, 30); } }

    function irAlForm() {

      medir('barra-ir');

      var dest = q('.tl-packs, .tf-precio, .dw-packs', root) || obj;

      dest.style.scrollMarginTop = (altoHeader() + 16) + 'px';

      dest.scrollIntoView({ block: 'start', behavior: quieto() ? 'auto' : 'smooth' });   /* sirve también cuando Horizon scrollea .page-wrapper */

    }

    function pagar(kind) {

      var b = kind === 'online' ? btnOnline() : btnCod();

      pendiente = function () {

        if (!b || b.disabled) return irAlForm();

        if (kind === 'cod' && fam !== 'gen' && !(W._rsi && W._rsi.form && b.classList.contains('_rsi-buy-now-button-product'))) return irAlForm();

        medir(kind === 'online' ? 'barra-online' : 'barra-cod');

        if (kind === 'cod') { H.classList.add('tsb-rsi'); vigilarRsi(); }

        /* marcas de un solo click: el listener de trendy_cta no lo cuenta dos veces y la hoja de FB no vuelve a preguntar */

        W.__trCtaSrc = 'barra';

        if (kind === 'online') b.dataset.trOk = '1';

        try { b.click(); } finally { W.__trCtaSrc = ''; if (kind === 'online') delete b.dataset.trOk; }

      };

      setTimeout(correrPendiente, 450);   /* respaldo si el "volver" del historial no dispara popstate */

      cerrar();

    }

    /* 16-10-2026 (14.4): la ventana "Vista previa de colores" (assets/trendy-vista.js) cierra y paga por acá, igual que esta

       hoja: mismo click en el botón real (Mercado Pago / Releasit), misma marca tsb-rsi mientras Releasit está abierto. */

    W.trendyHoja = {

      abrir: function () { abrir(); },

      pagar: function (kind) { pagar(kind === 'cod' ? 'cod' : 'online'); if (!(hoja && hoja.open)) correrPendiente(); }

    };

    qa('[data-tsb-open]', bar).forEach(function (b) { b.addEventListener('click', abrir); });



    /* otros botones de la página que solo subían al formulario abren la hoja: el cierre ("Elegí tu pack ↑", marcado con

       data-tsb-abrir en el Liquid) y los links a #tl-comprar / #dw-comprar ("Ver precio y comprar ↗" del dispensador).

       16-10 (14.2): sin hoja posible (todo agotado o navegador sin <dialog>) hacen lo de antes, subir a los packs: con el

       producto agotado, abrir() mandaba a WhatsApp. Sin JS o con la barra apagada (barra_off) esto ni se escucha. */

    root.addEventListener('click', function (ev) {

      var a = ev.target.closest && ev.target.closest('[data-tsb-abrir], a[href="#tl-comprar"], a[href="#dw-comprar"]');

      if (!a || a.closest('.tsb, dialog')) return;

      if (!tieneDialog || estado().agotadoTodo) {

        if (!a.matches('a[href^="#"]')) { ev.preventDefault(); irAlForm(); }   /* un botón sin ancla: lo subimos desde acá */

        return;   /* un link con ancla: el navegador sube solo, como antes */

      }

      ev.preventDefault(); abrir();

    });



    /* ── compartir ────────────────────────────────────────── */

    var ocupado = false;

    function precioLink(e) { if (e.modelo && e.modelo.now) return e.modelo.now; return e.unidad || e.total / (e.qty || 1); }

    function linkCon(fuente, e) {

      var v = e.modelo && e.modelo.id ? 'variant=' + e.modelo.id + '&' : '';

      return base + '?' + v + 'utm_source=' + fuente + '&utm_medium=share&utm_campaign=compartir&utm_content=barra';

    }

    function textoShare(e) { return '*' + nombre + '* a ' + fmt(precioLink(e)) + '\n' + (CFG.gancho ? CFG.gancho + '\n' : '') + 'Pagás online en hasta 12 cuotas o cuando te llega, con envío a todo Uruguay.'; }

    function waHref(e) { return 'https://api.whatsapp.com/send?text=' + encodeURIComponent(textoShare(e) + '\n' + linkCon('whatsapp', e)); }

    /* 17-10-2026: imagen para historias (1080x1920). Se arma en reposo (canvas, foto del mismo dominio para no

       ensuciar el lienzo) y se comparte como archivo: WhatsApp/Instagram la muestran como historia con foto y

       precio en vez de una tarjeta de texto. Si algo falla, se comparte el link como antes. */

    var historia = null, historiaPrecio = '';

    function mismaOrigen(u) {

      try { var x = new URL(u, location.href); return location.origin + x.pathname + (x.search ? x.search + '&' : '?') + 'width=1000'; } catch (er) { return ''; }

    }

    function lineas(ctx, t, max) {

      var pal = String(t).split(' '), out = [], l = '';

      pal.forEach(function (p) { var pr = l ? l + ' ' + p : p; if (ctx.measureText(pr).width > max && l) { out.push(l); l = p; } else l = pr; });

      if (l) out.push(l); return out.slice(0, 3);

    }

    function redondo(ctx, x, y, w, h, r) {

      ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);

      ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();

    }

    function armarHistoria() {

      var e = estado(), precio = fmt(precioLink(e));

      if (historia && historiaPrecio === precio) return;

      if (!W.HTMLCanvasElement || !W.File || !fotoBase) return;

      var src = mismaOrigen(fotoBase); if (!src) return;

      var img = new Image(); img.decoding = 'async';

      img.onload = function () {

        try {

          var c = d.createElement('canvas'); c.width = 1080; c.height = 1920;

          var x = c.getContext('2d'), F = 'system-ui,-apple-system,Segoe UI,Roboto,sans-serif';

          var g = x.createLinearGradient(0, 0, 1080, 1920); g.addColorStop(0, '#0B0E1C'); g.addColorStop(0.55, '#1A1030'); g.addColorStop(1, '#3A0F2A');

          x.fillStyle = g; x.fillRect(0, 0, 1080, 1920);

          var r = x.createRadialGradient(860, 320, 40, 860, 320, 700); r.addColorStop(0, 'rgba(255,106,26,.45)'); r.addColorStop(1, 'rgba(255,106,26,0)');

          x.fillStyle = r; x.fillRect(0, 0, 1080, 1920);

          x.fillStyle = '#fff'; x.font = '900 64px ' + F; x.textAlign = 'center'; var tw = x.measureText('TRENDY').width; x.fillText('TRENDY', 540 - 16, 170);

          x.fillStyle = '#FF2E93'; x.fillRect(540 - 16 + tw / 2 + 8, 148, 22, 22);

          x.save(); redondo(x, 90, 250, 900, 900, 56); x.fillStyle = '#fff'; x.fill(); x.clip();

          var s = Math.min(900 / img.naturalWidth, 900 / img.naturalHeight), w = img.naturalWidth * s, h = img.naturalHeight * s;

          x.drawImage(img, 90 + (900 - w) / 2, 250 + (900 - h) / 2, w, h); x.restore();

          x.fillStyle = '#fff'; x.font = '800 66px ' + F;

          var ls = lineas(x, nombre, 900), y = 1260;

          ls.forEach(function (l) { x.fillText(l, 540, y); y += 80; });

          y += 40; x.fillStyle = '#FF8A1A'; x.font = '900 150px ' + F; x.fillText(precio, 540, y + 110);

          y += 200; redondo(x, 140, y, 800, 96, 48); x.fillStyle = 'rgba(255,255,255,.12)'; x.fill();

          x.fillStyle = '#fff'; x.font = '700 40px ' + F; x.fillText('12 cuotas o pagás al recibir', 540, y + 62);

          x.fillStyle = 'rgba(255,255,255,.85)'; x.font = '800 46px ' + F; x.fillText('Pedilo en trendy.uy', 540, 1820);

          c.toBlob(function (b) { if (b) { historia = new File([b], 'trendy-historia.jpg', { type: 'image/jpeg' }); historiaPrecio = precio; } }, 'image/jpeg', 0.88);

        } catch (er) { historia = null; }

      };

      img.src = src;

    }

    if ('requestIdleCallback' in W) W.requestIdleCallback(armarHistoria, { timeout: 6000 }); else setTimeout(armarHistoria, 3000);

    bar.addEventListener('pointerdown', armarHistoria, { passive: true });

    function crearCompartir() {

      share = d.createElement('dialog');

      share.className = 'tsb-share';

      share.setAttribute('aria-labelledby', 'tsb-st');

      share.innerHTML = '<div class="tsb-in"><div class="tsb-grab" aria-hidden="true"></div>' +

        '<button type="button" class="tsb-x" data-tsb-x aria-label="Cerrar">' + ICO.x + '</button>' +

        '<div class="tsb-hd"><img alt="" width="56" height="56"><div><p class="tsb-k">Compartir</p><h2 id="tsb-st"></h2></div></div>' +

        '<a class="tsb-wa" data-tsb-wa href="#">' + ICO.wa + 'Mandar por WhatsApp</a>' +

        '<button type="button" class="tsb-cp" data-tsb-cp>' + ICO.copia + 'Copiar link</button>' +

        '<input class="tsb-url" readonly aria-label="Link del producto">' +

        '<p class="tsb-toast" aria-live="polite"></p></div>';

      d.body.appendChild(share);

      share.addEventListener('click', function (ev) {

        if (ev.target === share || ev.target.closest('[data-tsb-x]')) return cerrarCompartir();

        var a = ev.target.closest('[data-tsb-wa]');

        if (a) {

          medir('compartir', { canal: 'whatsapp' });

          /* salir reemplazando la entrada {tsb}: así "atrás" desde WhatsApp vuelve a la ficha y no a una entrada muerta */

          if (shareEmp) { ev.preventDefault(); shareEmp = false; location.replace(a.href); }

          return;

        }

        if (ev.target.closest('[data-tsb-cp]')) copiar();

      });

      share.addEventListener('close', function () {

        H.classList.remove('tsb-dlg');

        if (shareEmp) { shareEmp = false; history.back(); }

      });

    }

    function abrirCompartir() {

      var e = estado();

      if (!tieneDialog) { location.href = waHref(e); return; }

      if (!share) crearCompartir();

      cerrar();

      q('#tsb-st', share).textContent = CFG.share_titulo || 'Mandáselo a quien lo necesita';

      var im = q('.tsb-hd img', share), f = ancho(fotoBase, 160); if (f) im.src = f; else im.hidden = true;

      q('[data-tsb-wa]', share).href = waHref(e);

      q('.tsb-url', share).value = linkCon('copy', e);

      q('.tsb-toast', share).textContent = '';

      share.showModal();

      H.classList.add('tsb-dlg');

      shareEmp = empujar();

      try { q('[data-tsb-wa]', share).focus({ preventScroll: true }); } catch (x) {}

    }

    function cerrarCompartir() { if (share && share.open) share.close(); }

    function avisar(t) { q('.tsb-toast', share).textContent = t; }

    function copiar() {

      var u = q('.tsb-url', share).value;

      function ok() { avisar('Link copiado ✓'); medir('compartir', { canal: 'copiar' }); }

      function viejoCopiar() {

        var ta = d.createElement('textarea'); ta.value = u; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;top:-1000px;opacity:0';

        share.appendChild(ta); ta.select(); var r = false; try { r = d.execCommand('copy'); } catch (e) {}

        share.removeChild(ta);

        if (r) ok(); else { var inp = q('.tsb-url', share); inp.focus(); inp.select(); avisar('Mantené apretado el link para copiarlo'); medir('compartir', { canal: 'copiar_error' }); }

      }

      if (navigator.clipboard && navigator.clipboard.writeText && W.isSecureContext) navigator.clipboard.writeText(u).then(ok, viejoCopiar); else viejoCopiar();

    }

    q('[data-tsb-share]', bar).addEventListener('click', function () {

      if (ocupado) return;

      var e = estado();

      var fino = W.matchMedia && W.matchMedia('(pointer:fine)').matches;

      var datos = { title: nombre, text: textoShare(e), url: linkCon('native', e) };

      if (historia && typeof navigator.canShare === 'function' && navigator.canShare({ files: [historia] })) datos = { files: [historia], title: nombre, text: textoShare(e) + '\n' + linkCon('native', e) };

      if (!fino && typeof navigator.share === 'function' && (!navigator.canShare || navigator.canShare(datos))) {

        ocupado = true; medir('compartir', { canal: 'nativo' });

        navigator.share(datos).then(function () { medir('compartir', { canal: 'nativo_ok' }); })

          .catch(function (err) { if (err && err.name === 'AbortError') medir('compartir', { canal: 'cancelado' }); else abrirCompartir(); })

          .then(function () { ocupado = false; });

      } else abrirCompartir();

    });



    pintarBarra();

    setTimeout(pintarBarra, 1200);   /* por si la página termina de pintar sus totales después */

  }

  /* 01-11-2026 (dieta): arranca en el primer hueco libre después de DOMContentLoaded (tope 1,5 s), no sobre el primer pintado */
  function arrancar() { if (window.__tsb) return; if ('requestIdleCallback' in W) W.requestIdleCallback(init, { timeout: 1500 }); else setTimeout(init, 300); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  W.addEventListener('load', function () { if (!window.__tsb) init(); });

})();

